import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class SchoolCalenderStore {
  schoolCalender = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      schoolCalender: observable,
      total: observable,
      loading: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getSchoolCalender: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;

    var postData = { companyId: companyId };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("schoolCalender/getCalenderList", {
        params: postData,
      });

    this.schoolCalender = response?.data?.data;
    //  this.setCompanies(response?.data?.data?.companydata);
    this.total = parseInt(response?.data?.data?.TotalCount);
    // console.log(this.total);
    this.loading = false;
  }
  async deleteRecord({ calenderId }) {
    // var postData = {"calenderId":calenderId}
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("schoolCalender/deleteCalendar", {
        params: {
          calenderId: calenderId,
        },
      });
    return response;
  }

  async addData(postData) {
    // var postData ={"tokenId":"80bovn8u800tg1aq9bvr73kbhh",schoolCal:schoolCalenderData}
    var schoolCalenderData = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("schoolCalender/updateCalender", schoolCalenderData);

    return response.data;
  }

  async getSchoolCalender(calendarId) {
    console.log(calendarId);
    var postData = { calendarId: calendarId, limit: 1, offset: 0 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("schoolCalender/getCalenderList", {
        params: postData,
      });
    // var response = await postApi.getClient().post("index.php?c=calender&a=getcalender", "postData="+base64Input);

    return response.data.data[0];
  }
}

export default SchoolCalenderStore;
